import { useEffect, useRef, useState } from 'react';

import { CoinwebWalletMessage } from '../types';

/**
 * Keeps a stack of messages. Provide the latest message; the hook will append it
 * to the list whenever it changes (ignores identical consecutive values).
 */
export const useMessageStack = (message: CoinwebWalletMessage | null | undefined) => {
  const [messages, setMessages] = useState<CoinwebWalletMessage[]>([]);
  const lastMessageRef = useRef<CoinwebWalletMessage | null>(null);

  useEffect(() => {
    if (message && message.id !== lastMessageRef.current?.id && !messages.find((m) => m.id === message.id)) {
      setMessages((prev) => [...prev, message]);
      lastMessageRef.current = message;
    }
    if (!message) {
      lastMessageRef.current = message ?? null;
    }
  }, [message]);

  return messages;
};
